// Idempotency-Key helpers for hub booking writes (hub booking-write contract 2026-10-06 §3/§4).
// One key per USER SUBMIT. Keep it while the outcome is unknown (no response, timeout or 5xx:
// the channel MAY have booked) so a retry replays the SAME key; drop it only after a definite
// answer (2xx, or 4xx = nothing booked), so the next submit gets a fresh key.

// crypto.randomUUID needs a secure context (https / localhost); fall back to a v4 UUID
// built from crypto.getRandomValues, which every supported browser has.
export const newSubmitKey = () => {
  const c = typeof window !== "undefined" ? window.crypto : undefined;
  if (c && typeof c.randomUUID === "function") return c.randomUUID();
  const b = c.getRandomValues(new Uint8Array(16));
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
};

/** true when the hub gave a definite answer (2xx/4xx); false for network errors, timeouts, 5xx. */
export const isDefiniteOutcome = (errOrRes) => {
  const status = errOrRes && (errOrRes.response ? errOrRes.response.status : errOrRes.status);
  return Number.isInteger(status) && status < 500;
};
